"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _formValidations = require("../../../helpers/formValidations");
var _APNumberInput = _interopRequireDefault(require("../../common/APNumberInput"));
var _APInput = _interopRequireDefault(require("../../common/APInput"));
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _sendReceiveComponent = require("../../../propTypes/sendReceiveComponent");
require("./ReceiveForm.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('receive-form');
var allowedAmountValuesRange = (0, _formValidations.allowedNumberValuesRange)('0', '79228162514264337593543950335');
var ReceiveForm = /*#__PURE__*/function (_React$Component) {
  function ReceiveForm() {
    var _this;
    _classCallCheck(this, ReceiveForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ReceiveForm, [].concat(args));
    _defineProperty(_this, "checkUserEmail", function (value) {
      var userEmail = _this.props.userEmail;
      return (0, _formValidations.validateReceiverEmail)(value, userEmail);
    });
    return _this;
  }
  _inherits(ReceiveForm, _React$Component);
  return _createClass(ReceiveForm, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        _this$props$product = _this$props.product,
        name = _this$props$product.ProductFullName,
        symbol = _this$props$product.ProductSymbol,
        decimalPlaces = _this$props$product.DecimalPlaces,
        handleSubmit = _this$props.handleSubmit,
        invalid = _this$props.invalid,
        submitting = _this$props.submitting,
        onChange = _this$props.onChange,
        onSubmit = _this$props.onSubmit;
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit(onSubmit),
        className: bemClasses()
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses('receive-from')
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('label-text')
      }, t("Email Address to Request From")), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        name: "ReceiverUsername",
        customClass: bemClasses(),
        onChange: handleSubmit(onChange),
        validate: [_formValidations.required, _formValidations.email, this.checkUserEmail]
      })), /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('label-text')
      }, t("Amount of {{name}} to Request", {
        name: name
      })), /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses('amounts')
      }, /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
        name: "Amount",
        customClass: bemClasses(),
        labelInInput: symbol,
        decimalPlaces: decimalPlaces,
        onChange: handleSubmit(onChange),
        validate: [_formValidations.required, allowedAmountValuesRange]
      })), /*#__PURE__*/_react["default"].createElement("section", {
        className: bemClasses('note')
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: bemClasses('label-text')
      }, t("Add a Note "), /*#__PURE__*/_react["default"].createElement("em", null, t("(Optional)"))), /*#__PURE__*/_react["default"].createElement(_APInput["default"], {
        name: "Notes",
        rows: 3,
        customClass: bemClasses()
      })), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        type: "submit",
        customClass: bemClasses(),
        styleName: "additive",
        disabled: invalid || submitting
      }, t("Request"), " ", name));
    }
  }]);
}(_react["default"].Component);
ReceiveForm.propTypes = {
  product: _sendReceiveComponent.product.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onSubmit: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("send")(ReceiveForm);